import PaginatedList from "#root/components/paginated-list";
import { correspondenceCollection } from "#root/schema/correspondence";
import { monthNames } from "#root/utility/months";
import type { JSX, ReactNode } from "react";
import { Link } from "react-router-dom";
import PageLayout from "./layout";

export default function BillingCorrespondencesPage(): ReactNode {
  return (
    <PageLayout title="Billing - Correspondences">
      <PaginatedList title="Latest Corresponsence" collection={correspondenceCollection}>
        {({ rows }) => {
          let lastMonth: string | null = null;
          const elements: JSX.Element[] = [];

          for (const { id, date, accountName, subject } of rows) {
            const d = new Date(date);
            const month = monthNames[d.getMonth()] + " " + d.getFullYear();

            if (month !== lastMonth) {
              elements.push(
                <tr>
                  <td colSpan={6} className="label-divider">
                    {month}
                  </td>
                </tr>,
                <tr>
                  <th>Ref</th>
                  <th>Date</th>
                  <th>Account Name</th>
                  <th>Subject</th>
                  <th>Action</th>
                </tr>,
              );
              lastMonth = month;
            }

            elements.push(
              <tr>
                <td>CI-{id}</td>
                <td>{new Date(date).toLocaleString()}</td>
                <td>{accountName}</td>
                <td>{subject}</td>
                <td>
                  <Link to={`/billing/correspondence/${id}`}>Preview</Link>&nbsp;&middot;&nbsp;
                  <Link to={`/billing/correspondence/${id}/edit`}>Edit</Link>
                </td>
              </tr>,
            );
          }
          return (
            <table>
              <tbody>{elements}</tbody>
            </table>
          );
        }}
      </PaginatedList>
    </PageLayout>
  );
}
